import React from 'react';
import * as R from 'ramda';
// forms
import { Fieldset2 } from '../../formik/fieldset2/fieldset';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// icons
import * as I from '../../../svgs';
// ui
import { Box, Flex } from '../../../ui';
// feature accessorial-form
import {
  matrixVariableFields,
  defaultMatrixVariableFields,
} from './field-settings';
//////////////////////////////////////////////////

const lightblueColor = G.getTheme('colors.light.blue');

const MatrixVariablesSection = (props) => {
  const {
    push,
    form,
    remove,
  } = props;

  const { values, setFieldValue } = form;

  const matrixVariables = R.pathOr(
    [],
    ['values', GC.FIELD_ACCESSORIAL_MATRIX_VARIABLES],
    form,
  );

  const arrayLength = R.length(matrixVariables);
  const shared = G.getPropFromObject('shared', values);

  const handleAddRow = () => {
    if (shared) return;

    push(defaultMatrixVariableFields());
  };

  const handleRemoveRow = (rowIndex) => {
    if (R.equals(arrayLength, 1)) {
      setFieldValue(GC.FIELD_ACCESSORIAL_MATRIX_UOM, null);
      setFieldValue(GC.FIELD_ACCESSORIAL_MATRIX_TYPE, null);
    }

    remove(rowIndex);
  };

  return (
    <Box mb={10}>
      <Flex mb={20}>
        <Flex
          cursor='pointer'
          width='max-content'
          onClick={handleAddRow}
        >
          <Box fontWeight='bold' color={lightblueColor}>
            {G.getWindowLocale('titles:matrix-variables', 'Matrix Variables')}
          </Box>
          {
            R.not(shared) &&
            <Box ml={10}>
              {I.plusRound()}
            </Box>
          }
        </Flex>
      </Flex>
      {
        G.isNotNilAndNotEmpty(matrixVariables) &&
        matrixVariables.map((_, index) => (
          <Flex key={index}>
            {
              R.not(shared) &&
              <Box
                mr={10}
                mb={20}
                cursor='pointer'
                onClick={() => handleRemoveRow(index)}
              >
                {I.trash()}
              </Box>
            }
            <Fieldset2
              {...G.getFormikProps(form)}
              itemIndex={index}
              fieldsetType='array'
              arrayLength={arrayLength}
              fields={matrixVariableFields}
              arrayName={GC.FIELD_ACCESSORIAL_MATRIX_VARIABLES}
              fieldsWrapperStyles={{ mb: G.ifElse(R.equals(R.inc(index), arrayLength), 15, 25) }}
            />
          </Flex>
        ))
      }
    </Box>
  );
};

export default MatrixVariablesSection;
